/* Elanrah — minimal JS. WhatsApp concierge + mobile menu + scroll-reveal + form stub. */

// ── Concierge config ─────────────────────────────────────────────────────
// Atelier WhatsApp Business number (+971 52 266 8850), international format,
// digits only. Used by the floating button and every "speak to a stylist"
// CTA across the site.
window.ELANRAH_WHATSAPP = window.ELANRAH_WHATSAPP || "971522668850";

function elanrahWaLink(message) {
  const num = window.ELANRAH_WHATSAPP;
  const text = encodeURIComponent(message || "Hello Elanrah — I'd like to speak with a stylist about a gown.");
  return `https://wa.me/${num}?text=${text}`;
}

(function () {
  // Floating WhatsApp concierge — injected on every page so the atelier is
  // always one tap away (the dominant luxury sales channel in the GCC).
  if (!document.querySelector(".wa-float")) {
    const a = document.createElement("a");
    a.className = "wa-float";
    // Ready-to-Wear pages ([data-rtw] on <body>) drop the stylist wording —
    // RTW is not haute couture (Lubna 2026-09-22); the WhatsApp line stays.
    // Bridal and Evening pages ([data-bridal] / [data-evening]) use the same neutral wording.
    const bridal = document.body.hasAttribute("data-bridal");
    const evening = document.body.hasAttribute("data-evening");
    const acc = document.body.hasAttribute("data-acc");
    const rtw = bridal || evening || acc || document.body.hasAttribute("data-rtw");
    a.href = elanrahWaLink(bridal ? "Hello Elanrah — I have a question about the Bridal collection."
      : evening ? "Hello Elanrah — I have a question about the Evening collection."
      : acc ? "Hello Elanrah — I have a question about an accessory."
      : rtw ? "Hello Elanrah — I have a question about the Ready-to-Wear collection." : undefined);
    a.target = "_blank";
    a.rel = "noopener";
    a.setAttribute("aria-label", rtw ? "Chat with Elanrah on WhatsApp" : "Chat with an Elanrah stylist on WhatsApp");
    a.innerHTML =
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.004c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02ZM12.04 20.15h-.003a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24a8.2 8.2 0 0 1 5.83 2.42 8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.25 8.24Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43-.14 0-.31-.01-.47-.01s-.43.06-.65.31c-.23.25-.86.84-.86 2.05s.88 2.38 1.01 2.54c.12.17 1.74 2.66 4.21 3.73.59.25 1.05.41 1.4.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28Z"/></svg>' +
      '<span class="wa-float__label">' + (rtw ? "WhatsApp us" : "Speak to a stylist") + '</span>';
    document.body.appendChild(a);
  }

  // Wire any inline concierge CTAs that carry a data-wa-message (PDPs).
  document.querySelectorAll("[data-wa-message]").forEach((el) => {
    el.setAttribute("href", elanrahWaLink(el.getAttribute("data-wa-message")));
    el.setAttribute("target", "_blank");
    el.setAttribute("rel", "noopener");
  });

  // PDP gallery — dots under the image (Kevin 2026-10-30), looping arrows, click-to-zoom.
  document.querySelectorAll("[data-carousel]").forEach((carousel) => {
    const slides = Array.from(carousel.children);
    const gallery = carousel.closest(".pdp__gallery") || carousel.parentElement;
    const wrap = carousel.closest(".pdp__carousel-wrap") || carousel.parentElement;
    const dotsWrap = gallery ? gallery.querySelector("[data-dots]") : null;
    const prev = wrap.querySelector("[data-carousel-prev]");
    const next = wrap.querySelector("[data-carousel-next]");
    const imgs = slides.map((s) => s.querySelector("img")).filter(Boolean);
    const srcs = imgs.map((im) => im.getAttribute("src"));
    const n = slides.length;

    // Step = one slide. Slides are 100% wide everywhere except the bridal
    // desktop gallery (two full-length frames side by side), so this equals
    // clientWidth on every other PDP.
    const step = () => (slides[0] && slides[0].getBoundingClientRect().width) || carousel.clientWidth;
    const indexNow = () => Math.round(carousel.scrollLeft / step());
    // Looping: wrap past either end (Lubna — "left and right should keep going in a loop").
    // `last` is the last index that can sit at the left edge (n−1 with one
    // slide in view, n−2 with two); arrows wrap past it, thumbnails clamp to it.
    const last = () => Math.max(0, n - Math.round(carousel.clientWidth / step()));
    const goTo = (i, wrap = true) => {
      const max = last();
      const j = i > max ? (wrap ? 0 : max) : i < 0 ? max : i;
      carousel.scrollTo({ left: step() * j, behavior: "smooth" });
    };

    // One dot per image under the carousel; tap a dot to jump to that image
    const dots = (n > 1 && dotsWrap)
      ? imgs.map((img, i) => {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "pdp__dot" + (i === 0 ? " is-active" : "");
          b.setAttribute("aria-label", "View image " + (i + 1) + " of " + n);
          b.addEventListener("click", () => goTo(i, false));
          dotsWrap.appendChild(b);
          return b;
        })
      : [];

    const setActive = () => {
      const i = indexNow();
      dots.forEach((d, di) => d.classList.toggle("is-active", di === i));
    };
    let raf = null;
    carousel.addEventListener("scroll", () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
    });
    if (n > 1 && prev) prev.addEventListener("click", () => goTo(indexNow() - 1));
    if (n > 1 && next) next.addEventListener("click", () => goTo(indexNow() + 1));
    if (n <= 1) { if (prev) prev.style.display = "none"; if (next) next.style.display = "none"; }

    // Click any gallery image → open the quality-zoom lightbox at that index.
    imgs.forEach((img, i) => {
      img.style.cursor = "zoom-in";
      img.addEventListener("click", () => window.elanrahLightbox && window.elanrahLightbox(srcs, i));
    });
  });
  // Mobile menu — full-screen drawer. Toggles `is-open` on the header,
  // locks body scroll, and closes when any nav link is tapped.
  const toggle = document.querySelector('.menu-toggle');
  const header = document.querySelector('.header');
  if (toggle && header) {
    const setOpen = (open) => {
      header.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    };
    toggle.addEventListener('click', () => setOpen(!header.classList.contains('is-open')));
    header.querySelectorAll('.nav a').forEach((a) =>
      a.addEventListener('click', () => setOpen(false))
    );
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header.classList.contains('is-open')) setOpen(false);
    });
  }

  // Subtle scroll-reveal on .looks > .look and .process-step (haute couture =
  // restrained motion, no bouncy easing per house rule)
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.look, .process-step, .story__body, .pdp__spec, .catalogue__page, .cat-teaser__card').forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = `opacity 800ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 60}ms, transform 800ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 60}ms`;
      io.observe(el);
    });

    // Hand-drawn line icons — each draws itself on once when it scrolls into
    // view. `craft-ready` on <html> arms the CSS (no-JS visitors see the full
    // icon instead of an empty box). Restrained, no looping — house rule.
    document.documentElement.classList.add('craft-ready');
    const drawIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-drawn');
          drawIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.craft-icon').forEach((el) => drawIO.observe(el));

    // Hover-replay: re-draw a craft card's icon on pointer enter (desktop only;
    // touch devices skip this and keep the scroll-triggered draw).
    if (window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('.craftcard').forEach((card) => {
        card.addEventListener('mouseenter', () => {
          const ic = card.querySelector('.craft-icon');
          if (!ic) return;
          ic.classList.remove('is-drawn');
          void ic.getBoundingClientRect(); // force reflow so the redraw restarts
          ic.classList.add('is-drawn');
        });
      });
    }
  }

  // Reservation form — for v1 this captures + posts to a stub; in production
  // this hits a Vercel function or Formspree-style endpoint. For now: log,
  // show success.
  document.querySelectorAll('form[data-form="reserve"]').forEach((form) => {
    form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const data = Object.fromEntries(new FormData(form).entries());
      console.log('[Elanrah reserve]', data);
      const ok = form.querySelector('.form__ok');
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Received'; }
      if (ok) ok.hidden = false;
      // In production: fetch('/api/reserve', { method: 'POST', body: JSON.stringify(data) })
    });
  });
})();

/* ── Catalogue email-gate ───────────────────────────────────────────────────
   The catalogue is a lead magnet: the flip-through reader stays locked until a
   visitor leaves an email, then we deliver the PDF and reveal the reader. The
   unlock is remembered so returning visitors aren't re-gated. In production the
   email posts to Klaviyo (a list/subscribe endpoint) — here it logs to a stub. */
(function () {
  const gate = document.querySelector('[data-cat-gate]');
  const reader = document.querySelector('[data-cat-reader]');
  if (!gate || !reader) return;

  const KEY = 'elanrah_cat_unlocked';
  // Shopify build passes the fingerprinted asset URL via data-pdf; static falls back.
  const PDF = gate.getAttribute('data-pdf') || 'assets/elanrah-catalogue.pdf';

  const reveal = (withDownload) => {
    gate.hidden = true;
    reader.hidden = false;
    if (withDownload) {
      const a = document.createElement('a');
      a.href = PDF;
      a.download = 'Elanrah-Catalogue-Season-01.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  };

  // Returning visitor — already unlocked.
  let unlocked = false;
  try { unlocked = !!localStorage.getItem(KEY); } catch (_) {}
  if (unlocked) { reveal(false); return; }

  const form = gate.querySelector('[data-cat-form]');
  if (!form) return;
  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    const email = String(new FormData(form).get('email') || '').trim();
    if (!email) return;
    console.log('[Elanrah catalogue lead]', email);
    // On Shopify (gate carries data-capture="shopify") the lead is stored as a
    // real customer record via the native /contact customer form — no app
    // needed. Fire-and-forget so the download is never blocked.
    if (gate.getAttribute('data-capture') === 'shopify') {
      try {
        fetch('/contact', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            form_type: 'customer', utf8: '✓',
            'contact[email]': email,
            'contact[tags]': 'catalogue-download,newsletter',
          }).toString(),
        }).catch(function () {});
      } catch (_) {}
    }
    try { localStorage.setItem(KEY, '1'); } catch (_) {}
    reveal(true);
    // smooth-scroll the freshly revealed reader into view
    reader.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* ── PDP size sheet + size-guide popup ──────────────────────────────────────
   The buy box "Size" line opens a couture size picker — bottom sheet on
   mobile, centred modal on desktop. Choosing a size fills the hidden
   properties[Size] input (travels to cart/checkout as a line-item property)
   and updates the row. Submitting the buy form without a size opens the
   sheet instead (capture phase, so it runs before any other submit handler).
   The measurement guide is a SECOND popup ([data-sizeguide]) — on pages that
   carry it, every size-guide link opens it in place instead of navigating
   (the href stays as the no-JS fallback). Restrained motion; Esc/backdrop/X
   all close. */
(function () {
  const sheet = document.querySelector('[data-sizesheet]');
  const guide = document.querySelector('[data-sizeguide]');
  const row = document.querySelector('[data-size-open]');
  if (!sheet || !row) return;
  const display = document.querySelector('[data-size-display]');
  const input = document.querySelector('input[data-size-required]');
  const form = input ? input.closest('form') : null;
  const opts = Array.from(sheet.querySelectorAll('.sizesheet__opt'));
  let lastFocus = null;

  const openOverlay = (el) => {
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  };
  const closeOverlay = (el, keepLock) => {
    el.classList.remove('is-open');
    if (!keepLock) document.body.style.overflow = '';
    window.setTimeout(() => { el.hidden = true; }, 260);
    if (!keepLock && lastFocus && lastFocus.focus) lastFocus.focus();
  };

  row.addEventListener('click', () => openOverlay(sheet));
  sheet.querySelectorAll('[data-size-close]').forEach((el) => el.addEventListener('click', () => closeOverlay(sheet)));
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (guide && !guide.hidden) closeOverlay(guide);
    else if (!sheet.hidden) closeOverlay(sheet);
  });

  opts.forEach((opt) => opt.addEventListener('click', () => {
    const v = opt.getAttribute('data-size-value-opt');
    if (input) input.value = v;
    display.textContent = opt.getAttribute('data-size-label') || v;
    row.classList.add('is-chosen');
    opts.forEach((o) => o.classList.toggle('is-active', o === opt));
    closeOverlay(sheet);
  }));

  // Gentle requirement: no size chosen → the buy button opens the sheet.
  if (form) form.addEventListener('submit', (e) => {
    if (input && !input.value) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay(sheet);
    }
  }, true);

  // ── measurement-guide popup ──
  if (guide) {
    guide.querySelectorAll('[data-guide-close]').forEach((el) => el.addEventListener('click', () => closeOverlay(guide)));
    const back = guide.querySelector('[data-back-to-sizes]');
    if (back) back.addEventListener('click', () => { closeOverlay(guide, true); openOverlay(sheet); });
    // every size-guide link on this page opens the popup instead of navigating
    // (anchored ones too: "size-guide.html#bridal-sizes", "/pages/size-guide#rtw-sizes")
    document.querySelectorAll('a[href*="size-guide.html"], a[href^="/pages/size-guide"]').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        if (!sheet.hidden) closeOverlay(sheet, true);
        openOverlay(guide);
      });
    });
  }
})();

/* ── Welcome-offer + catalogue popup ───────────────────────────────────────
   Two modes, one overlay (reuses the .sizesheet system):
   • offer (auto, 20s into a first browse): "10% off your first order" in
     exchange for an email; signing up to email marketing is the condition
     and the fine print says so (Lubna 2026-09-30). Success shows the code
     and, on Shopify, applies it to the visitor's bag via /discount/<code>.
   • catalogue (manual, the [data-news-open] "Receive the catalogue" CTAs):
     the Season 01 catalogue for an email.
   Shows once per visitor (dismiss = quiet for 30 days, submit = never
   again), never on the catalogue or cart pages. On Shopify the email is a
   real Customer with marketing consent (form_type=customer). The background
   POST checks r.ok AND the final URL: with spam protection on, Shopify can
   answer a script POST with its /challenge page (a 200), so a challenged
   signup falls back to a native form submit — the visitor completes the
   check, Shopify redirects back with ?customer_posted=true, and the popup
   reopens on the success state. Opening never waits on rAF (a hidden tab
   stalls it); a forced reflow starts the transition instead. */
(function () {
  // live: only while the code exists in Shopify Discounts (WELCOME10 created
  // 2026-10-07: 10%, Ready-to-Wear + Bridal collections, once per customer,
  // segment "Customers who haven't purchased"); false = auto popup falls back
  // to the catalogue offer, so no visitor is handed a dead code
  var OFFER = { code: 'WELCOME10', pct: 10, live: true };
  var KEY_DONE = 'elanrah_news_done';
  var KEY_SNOOZE = 'elanrah_news_snooze';
  var KEY_CAT = 'elanrah_cat_unlocked';
  var KEY_PENDING = 'elanrah_offer_pending';
  var onShopify = !!window.Shopify;
  var logoSrc = (document.querySelector('.wordmark__logo') || {}).src || 'assets/logo/elanrah-logo-ink.png';
  var catalogueHref = onShopify ? '/pages/catalogue' : 'catalogue.html';
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (_) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (_) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (_) {} }
  };

  var COPY = {
    offer: {
      label: 'Claim 10% off your first order',
      eyebrow: 'Welcome to Elanrah',
      title: OFFER.pct + '% off<br/>your first order.',
      sub: 'Join the Elanrah list for new pieces and private appointments, and take ' + OFFER.pct + '% off your first order.',
      cta: 'Claim my ' + OFFER.pct + '%',
      fine: 'By signing up you agree to receive marketing emails from Elanrah. Unsubscribe anytime. One use per customer, on your first order. Excludes haute couture.',
      skip: 'No thanks',
      tags: 'newsletter,welcome-offer'
    },
    catalogue: {
      label: 'Receive the catalogue',
      eyebrow: 'The Season 01 Catalogue',
      title: 'The catalogue,<br/>to your inbox.',
      sub: 'Leave your email and we’ll send the complete Season 01 catalogue, and write to you when something deserves your attention.',
      cta: 'Send me the catalogue',
      fine: 'By signing up you agree to receive marketing emails from Elanrah. Unsubscribe anytime.',
      skip: 'Perhaps later',
      tags: 'newsletter,catalogue-popup'
    }
  };

  function doneHtml(mode) {
    if (mode === 'catalogue') {
      return '<p class="newspop__title">It’s on its way.</p>' +
        '<p class="newspop__sub">The catalogue will arrive in your inbox shortly. <a href="' + catalogueHref + '" style="border-bottom:1px solid var(--border-strong);">View it now</a>.</p>';
    }
    return '<p class="newspop__title">Your ' + OFFER.pct + '% is ready.</p>' +
      '<p class="newspop__sub">Use this code at checkout' + (onShopify ? ', or simply continue: it is already applied to your bag.' : '.') + '</p>' +
      '<p class="newspop__code" aria-label="Discount code">' + OFFER.code + '</p>' +
      '<p class="newspop__sub" style="margin-bottom:0;"><a href="' + catalogueHref + '" style="border-bottom:1px solid var(--border-strong);">Browse the catalogue</a></p>';
  }

  function build(mode) {
    var c = COPY[mode];
    var el = document.createElement('div');
    el.className = 'sizesheet newspop';
    el.hidden = true;
    el.innerHTML =
      '<div class="sizesheet__backdrop" data-news-close></div>' +
      '<div class="sizesheet__panel newspop__panel" role="dialog" aria-modal="true" aria-label="' + c.label + '">' +
        '<span class="sizesheet__grab" aria-hidden="true"></span>' +
        '<button type="button" class="sizesheet__x" data-news-close aria-label="Close" style="position:absolute;top:16px;right:16px;">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div data-news-ask>' +
          '<img class="newspop__logo" src="' + logoSrc + '" alt="Elanrah" />' +
          '<hr class="newspop__rule" />' +
          '<p class="newspop__eyebrow">' + c.eyebrow + '</p>' +
          '<p class="newspop__title">' + c.title + '</p>' +
          '<p class="newspop__sub">' + c.sub + '</p>' +
          '<form class="newspop__form" data-news-form method="post" action="/contact#newspop" accept-charset="UTF-8">' +
            '<input type="hidden" name="form_type" value="customer" />' +
            '<input type="hidden" name="utf8" value="✓" />' +
            '<input type="hidden" name="contact[tags]" value="' + c.tags + '" />' +
            '<input type="email" name="contact[email]" required autocomplete="email" placeholder="Your email address" aria-label="Email address" />' +
            '<button type="submit" class="btn btn--lg" style="width:100%;">' + c.cta + '</button>' +
          '</form>' +
          '<p class="newspop__fine">' + c.fine + '</p>' +
          '<button type="button" class="newspop__skip" data-news-close>' + c.skip + '</button>' +
        '</div>' +
        '<div class="newspop__done" data-news-done hidden>' +
          '<hr class="newspop__rule" />' + doneHtml(mode) +
        '</div>' +
      '</div>';
    return el;
  }

  function applyOffer() {
    if (!onShopify) return;
    // stores the code on the visitor's session; checkout applies it
    fetch('/discount/' + encodeURIComponent(OFFER.code), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('discount ' + r.status); })
      .catch(function (err) { console.warn('[Elanrah offer]', err.message); });
  }

  function markDone() {
    store.set(KEY_DONE, '1');
    store.set(KEY_CAT, '1'); // one email unlocks the catalogue gate too
  }

  function show(mode, startDone) {
    if (document.querySelector('.newspop')) return; // already open
    var pop = build(mode);
    document.body.appendChild(pop);
    pop.hidden = false;
    void pop.offsetWidth; // forced reflow starts the transition (never rAF)
    pop.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var ask = pop.querySelector('[data-news-ask]');
    var done = pop.querySelector('[data-news-done]');
    var showDone = function () { ask.hidden = true; done.hidden = false; };
    if (startDone) showDone();

    var close = function () {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { pop.remove(); }, 280);
      if (!store.get(KEY_DONE)) store.set(KEY_SNOOZE, String(Date.now()));
    };
    pop.querySelectorAll('[data-news-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape' && document.body.contains(pop)) { close(); document.removeEventListener('keydown', esc); }
    });

    var form = pop.querySelector('[data-news-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = String(form.elements['contact[email]'].value || '').trim();
      if (!email) return;
      var btn = form.querySelector('button[type="submit"]');
      var finish = function () {
        markDone();
        if (mode === 'offer') applyOffer();
        showDone();
      };
      if (!onShopify) { console.log('[Elanrah newsletter]', mode, email); finish(); return; } // static stub
      btn.disabled = true;
      fetch('/contact', { method: 'POST', body: new URLSearchParams(new FormData(form)), credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('signup ' + r.status);
          if (/\/challenge/.test(r.url)) throw new Error('challenge');
          finish();
        })
        .catch(function () {
          // spam check (or a failed POST): hand the same form to the browser,
          // Shopify runs its check and redirects back with ?customer_posted=true
          if (mode === 'offer') store.set(KEY_PENDING, String(Date.now()));
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  }

  // Back from a native (challenged) signup: open straight on the success state.
  if (OFFER.live && /[?&]customer_posted=true/.test(location.search) && store.get(KEY_PENDING)) {
    store.del(KEY_PENDING);
    markDone();
    applyOffer();
    show('offer', true);
  }

  // Manual triggers — the footer + homepage "Receive the catalogue" CTAs.
  // These always open it, even for visitors who already subscribed.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-news-open]');
    if (t) { e.preventDefault(); show('catalogue'); }
  });

  // Auto: 20s in, once per visitor, never on the catalogue/cart pages or for
  // anyone who's already given an email.
  function eligibleAuto() {
    if (store.get(KEY_DONE) || store.get(KEY_CAT)) return false;
    var sn = parseInt(store.get(KEY_SNOOZE) || '0', 10);
    if (sn && Date.now() - sn < 30 * 24 * 3600 * 1000) return false;
    var p = location.pathname;
    if (document.documentElement.hasAttribute('data-cart-open')) return false;
    return !(/catalogue/.test(p) || /\/cart/.test(p) || /\/checkouts?\//.test(p));
  }
  var AUTO_MODE = OFFER.live ? 'offer' : 'catalogue';
  if (eligibleAuto()) setTimeout(function () { if (eligibleAuto()) show(AUTO_MODE); }, 20000);
})();

/* ── Wishlist — localStorage hearts on the lookbook cards ───────────────────
   No accounts yet, so favourites live in the browser. The heart fills when
   saved; a future wishlist page (or Klaviyo) can read elanrah_wishlist. */
(function () {
  var KEY = 'elanrah_wishlist';
  var hearts = document.querySelectorAll('[data-wish]');
  if (!hearts.length) return;
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; } };
  var write = function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (_) {} };
  var saved = read();
  hearts.forEach(function (btn) {
    var id = btn.getAttribute('data-wish');
    if (saved.indexOf(id) !== -1) btn.classList.add('is-saved');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var list = read();
      var i = list.indexOf(id);
      if (i === -1) { list.push(id); btn.classList.add('is-saved'); }
      else { list.splice(i, 1); btn.classList.remove('is-saved'); }
      write(list);
    });
  });
})();

/* ── Image lightbox — full-screen quality zoom with pan, loop, keyboard ──────
   Opened via window.elanrahLightbox(srcs, startIndex) from the PDP gallery.
   Click/tap the image to toggle 2.4× zoom (origin follows the cursor on
   desktop for panning); ‹ › and arrow keys loop through the gown's photos;
   Esc / ✕ / backdrop close. Shows the full-size image for the crispest zoom
   the source allows. */
(function () {
  var box, stage, imgEl, countEl, list = [], idx = 0, zoomed = false;

  function setOrigin(e) {
    var r = imgEl.getBoundingClientRect();
    var px = e.touches ? e.touches[0].clientX : e.clientX;
    var py = e.touches ? e.touches[0].clientY : e.clientY;
    var x = Math.min(100, Math.max(0, ((px - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((py - r.top) / r.height) * 100));
    imgEl.style.transformOrigin = x + "% " + y + "%";
  }
  function unzoom() { zoomed = false; box.classList.remove("is-zoomed"); imgEl.style.transform = ""; }
  function load() {
    unzoom();
    imgEl.src = list[idx];
    if (countEl) countEl.textContent = (idx + 1) + " / " + list.length;
  }
  function go(d) { idx = ((idx + d) % list.length + list.length) % list.length; load(); }

  function build() {
    box = document.createElement("div");
    box.className = "lightbox";
    box.innerHTML =
      '<button class="lightbox__close" data-lb-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
      '<button class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous">&lsaquo;</button>' +
      '<div class="lightbox__stage" data-lb-stage><img class="lightbox__img" alt="" /></div>' +
      '<button class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next">&rsaquo;</button>' +
      '<div class="lightbox__count" data-lb-count></div>';
    document.body.appendChild(box);
    stage = box.querySelector("[data-lb-stage]");
    imgEl = box.querySelector(".lightbox__img");
    countEl = box.querySelector("[data-lb-count]");

    box.querySelectorAll("[data-lb-close]").forEach(function (el) { el.addEventListener("click", close); });
    box.addEventListener("click", function (e) { if (e.target === box) close(); });
    box.querySelector("[data-lb-prev]").addEventListener("click", function (e) { e.stopPropagation(); go(-1); });
    box.querySelector("[data-lb-next]").addEventListener("click", function (e) { e.stopPropagation(); go(1); });

    stage.addEventListener("click", function (e) {
      zoomed = !zoomed;
      box.classList.toggle("is-zoomed", zoomed);
      if (zoomed) { setOrigin(e); imgEl.style.transform = "scale(2.4)"; }
      else imgEl.style.transform = "";
    });
    stage.addEventListener("mousemove", function (e) { if (zoomed) setOrigin(e); });

    document.addEventListener("keydown", function (e) {
      if (!box.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") go(-1);
      else if (e.key === "ArrowRight") go(1);
    });
  }

  function close() {
    box.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () { unzoom(); }, 50);
  }

  window.elanrahLightbox = function (srcs, start) {
    if (!srcs || !srcs.length) return;
    if (!box) build();
    list = srcs;
    idx = start || 0;
    load();
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add("is-open"); });
    document.body.style.overflow = "hidden";
  };
})();

/* ── Ready-to-Wear: collection filter + mobile strip dots ─────────────────
   Cards render visible in the markup; the filter only toggles [hidden], so a
   JS failure leaves the full collection on screen. On Shopify the same chips
   drive the Liquid-rendered grid (cards carry data-cat from product tags). */
(function () {
  const grid = document.querySelector('[data-rtw-grid]');
  const chips = document.querySelectorAll('[data-rtw-filter]');
  if (grid && chips.length) {
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const cat = chip.getAttribute('data-rtw-filter');
      chips.forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      grid.querySelectorAll('.rtw-card').forEach((card) => {
        card.hidden = cat !== 'all' && card.getAttribute('data-cat') !== cat;
      });
    }));
  }

  const strip = document.querySelector('[data-rtw-more]');
  const dots = document.querySelector('[data-rtw-dots]');
  if (strip && dots) {
    const cards = strip.querySelectorAll('.rtw-card');
    cards.forEach(() => dots.appendChild(document.createElement('span')));
    const paint = () => {
      const w = cards[0] ? cards[0].getBoundingClientRect().width + 12 : 1;
      const i = Math.min(cards.length - 1, Math.round(strip.scrollLeft / w));
      dots.querySelectorAll('span').forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    strip.addEventListener('scroll', paint, { passive: true });
    paint();
  }
})();

/* ── Ready-to-Wear quick add ─────────────────────────────────────────────
   Size row on each card: hover (desktop) or the + button (touch) reveals
   it; a size click adds that piece to the bag without opening the PDP. On
   Shopify the card carries data-variant and posts to /cart/add.js (r.ok is
   checked — a 422 resolves with a JSON body); the static preview has no
   cart, so it only confirms. */
(function () {
  let toastEl, toastTimer;
  const toast = (msg, href) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rtw-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    if (href) {
      const a = document.createElement('a');
      a.href = href;
      a.textContent = 'View bag';
      toastEl.appendChild(a);
    }
    void toastEl.offsetWidth; // forced reflow (never rAF: hidden tabs stall it)
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 4500);
  };
  const closeAll = (except) => document.querySelectorAll('[data-quick].is-open').forEach((q) => {
    if (q === except) return;
    q.classList.remove('is-open');
    const o = q.querySelector('[data-quick-open]');
    if (o) o.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('click', async (e) => {
    const open = e.target.closest('[data-quick-open]');
    if (open) {
      const q = open.closest('[data-quick]');
      const on = !q.classList.contains('is-open');
      closeAll(q);
      q.classList.toggle('is-open', on);
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { const first = q.querySelector('[data-quick-size]'); if (first) first.focus({ preventScroll: true }); }
      return;
    }
    const btn = e.target.closest('[data-quick-size]');
    if (!btn) { if (!e.target.closest('[data-quick]')) closeAll(); return; }
    const q = btn.closest('[data-quick]');
    const size = btn.getAttribute('data-quick-size');
    const name = q.getAttribute('data-name') || 'Piece';
    const variant = q.getAttribute('data-variant');
    if (!variant) { toast(name + ' · ' + size + ' added to your bag'); closeAll(); return; }
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1, properties: { Size: size } }] }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'This piece could not be added. Please try again.');
      const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => (x.ok ? x.json() : null)).catch(() => null);
      if (c) document.querySelectorAll('[data-cart-link]').forEach((l) => { l.textContent = 'Cart (' + c.item_count + ')'; });
      if (window.elanrahCart) document.dispatchEvent(new CustomEvent('elanrah:cart-added'));
      else toast(name + ' · ' + size + ' added to your bag', '/cart');
    } catch (err) {
      toast(err.message);
    } finally {
      btn.disabled = false;
      closeAll();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
})();

/* ── Bridal: films + snap-strip dots ─────────────────────────────────────
   Films ship with poster + controls, so without JS (or with reduced motion)
   they are ordinary tap-to-play videos. With JS they play muted only while
   on screen, and drop the controls once playback has actually started. Any [data-snap-strip] gets dots from the
   [data-snap-dots] in the same section (the RTW strip keeps its own code). */
(function () {
  const films = document.querySelectorAll('video[data-film]');
  const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (films.length && !still && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => { v.controls = true; }); }
      else v.pause();
    }), { threshold: 0.35 });
    // controls go only once playback has really started, so a film whose
    // play() never fires stays a normal tap-to-play video
    films.forEach((v) => {
      v.muted = true;
      v.addEventListener('playing', () => { v.controls = false; }, { once: true });
      io.observe(v);
    });
  }

  document.querySelectorAll('[data-snap-strip]').forEach((strip) => {
    const scope = strip.closest('section') || strip.parentElement;
    const dots = scope && scope.querySelector('[data-snap-dots]');
    const items = Array.from(strip.children);
    if (!dots || items.length < 2) return;
    items.forEach(() => dots.appendChild(document.createElement('span')));
    const paint = () => {
      const w = items[0].getBoundingClientRect().width + 12;
      const i = Math.min(items.length - 1, Math.round(strip.scrollLeft / w));
      dots.querySelectorAll('span').forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    strip.addEventListener('scroll', paint, { passive: true });
    paint();
  });
})();

/* ── Bridal measurement fields ───────────────────────────────────────────
   Optional "<label> (cm)" inputs inside [data-measure]. Empty ones are
   disabled for the instant of submission so blank properties never reach the
   order, then re-enabled on the next tick (in case the size guard cancels the
   submit). Without JS, blanks are posted and the cart template hides them. */
document.addEventListener('submit', (e) => {
  const empties = Array.from(e.target.querySelectorAll('[data-measure] input')).filter((i) => !i.value.trim());
  empties.forEach((i) => { i.disabled = true; });
  setTimeout(() => empties.forEach((i) => { i.disabled = false; }), 0);
}, true);

/* ── Cart drawer (Shopify only) ──────────────────────────────────────────
   A state machine over Shopify's own cart: state.cart is the last /cart.js
   response and renderCart() repaints everything (items, quantities, upsell,
   totals, due-today, empty state, every [data-cart-link] count) from it.
   Opens from the header Cart link, after any product-form add (PDP buy box,
   cape row) and after the RTW quick add. Without JS the forms still post
   natively and return_to=/cart, so the full cart page stays the fallback.
   Not on the static preview (no window.Shopify) and not on /cart itself. */
(function () {
  if (!window.Shopify || !document.body) return;
  var onCartPage = /^\/cart\/?$/.test(location.pathname);
  var state = { cart: null, open: false, busy: false, error: '' };
  var MONEY = (window.ElanrahShop && window.ElanrahShop.moneyFormat) || '';
  var SHOP_CCY = (window.ElanrahShop && window.ElanrahShop.currency) || '';
  var CAPE = 'silver-sovereign-cape';
  var CAPE_FOR = 'silver-sovereign';

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  /* money_without_trailing_zeros: the shop's own format, ".00" dropped */
  var money = function (cents) {
    var ccy = state.cart && state.cart.currency;
    var n = (cents || 0) / 100;
    var whole = (cents || 0) % 100 === 0;
    if (MONEY && (!ccy || !SHOP_CCY || ccy === SHOP_CCY)) {
      var fmt = function (dec, th, ds) {
        var p = n.toFixed(whole ? 0 : dec).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return p.join(ds);
      };
      return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return fmt(0, ',', '.');
        if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
        if (k === 'amount_with_apostrophe_separator') return fmt(2, "'", '.');
        return fmt(2, ',', '.');
      }).replace(/<[^>]*>/g, '');
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: ccy || 'AED',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2,
      }).format(n);
    } catch (_) { return n.toFixed(whole ? 0 : 2); }
  };
  var getJSON = function (url, opts) {
    return fetch(url, Object.assign({ headers: { Accept: 'application/json' } }, opts || {})).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  };
  var postJSON = function (url, body) {
    return getJSON(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  };

  /* ── markup (built once, filled by renderCart) ── */
  var root = document.createElement('div');
  root.className = 'cartdrawer';
  root.hidden = true;
  var ICON = {
    hand: '<path d="M4 20c4-1 7-4 9-8l3-6"/><path d="M14 4l4 2-1.6 3.2"/><path d="M3 14c2.5.4 4.4 1.6 5.5 3.5"/>',
    measure: '<rect x="3" y="8" width="18" height="8" rx="1"/><path d="M7 8v3M11 8v4M15 8v3M19 8v2"/>',
    refund: '<path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4h4"/>',
    delivery: '<path d="M4 8l8-4 8 4v8l-8 4-8-4z"/><path d="M4 8l8 4 8-4M12 12v8"/>',
    clock: '<circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/>',
    quality: '<path d="M6 4h12l3 5-9 11L3 9z"/><path d="M3 9h18M9 4l3 16 3-16"/>',
    lock: '<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
    chat: '<path d="M5 18l1.2-3.4A7 7 0 1 1 9 18.1z"/>',
  };
  var svg = function (k, s) {
    return '<svg viewBox="0 0 24 24" width="' + (s || 20) + '" height="' + (s || 20) + '" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[k] + '</svg>';
  };
  root.innerHTML =
    '<div class="cartdrawer__scrim" data-cart-action="close"></div>' +
    '<aside class="cartdrawer__panel" role="dialog" aria-modal="true" aria-labelledby="cartdrawer-title" tabindex="-1">' +
      '<header class="cartdrawer__head">' +
        '<div class="cartdrawer__heading">' +
          '<p class="eyebrow cartdrawer__eyebrow" data-cart="eyebrow">Your bag</p>' +
          '<h2 class="cartdrawer__title" id="cartdrawer-title" data-cart="title">Your bag</h2>' +
          '<p class="cartdrawer__count" data-cart="count"></p>' +
        '</div>' +
        '<button type="button" class="cartdrawer__close" data-cart-action="close" aria-label="Close bag">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="cartdrawer__body">' +
        '<p class="cartdrawer__error" data-cart="error" role="alert" hidden></p>' +
        '<p class="cartdrawer__ship" data-cart="ship" hidden></p>' +
        '<div class="cartdrawer__items" data-cart="items"></div>' +
        '<div class="cartdrawer__upsell" data-cart="upsell" hidden></div>' +
        '<ul class="cartdrawer__usps" data-cart="usps" hidden></ul>' +
        '<div class="cartdrawer__recs" data-cart="recs" hidden></div>' +
        '<div class="cartdrawer__empty" data-cart="empty" hidden>' +
          '<hr class="rule rule--center" />' +
          '<p class="cartdrawer__empty-title">Your bag is empty.</p>' +
          '<p class="cartdrawer__empty-sub">Ready-to-Wear in sizes XS to L, each piece produced within one week of your order.</p>' +
          '<a href="/collections/ready-to-wear" class="btn btn--lg cartdrawer__empty-cta">Shop Ready-to-Wear</a>' +
          '<p class="cartdrawer__empty-links"><a href="/collections/bridal">Shop Bridal</a><span aria-hidden="true">·</span><a href="/pages/lookbook">Haute Couture</a></p>' +
        '</div>' +
      '</div>' +
      '<footer class="cartdrawer__foot" data-cart="foot" hidden>' +
        '<div class="cartdrawer__row"><span class="cartdrawer__label">Total</span><span class="cartdrawer__total" data-cart="total"></span></div>' +
        '<div class="cartdrawer__row cartdrawer__row--due" data-cart="due-row" hidden><span class="cartdrawer__label">Due today</span><span class="cartdrawer__due" data-cart="due"></span></div>' +
        '<p class="cartdrawer__note" data-cart="note"></p>' +
        '<form action="/cart" method="post" class="cartdrawer__checkout"><button type="submit" name="checkout" class="btn btn--lg">' + svg('lock', 16) + '<span>Checkout securely</span></button></form>' +
        '<p class="cartdrawer__wallets">Shop Pay · Apple Pay · Google Pay · Cards</p>' +
        '<p class="cartdrawer__view"><a href="/cart">View full bag</a><span aria-hidden="true">·</span><a href="#" data-cart-action="close">Continue shopping</a></p>' +
      '</footer>' +
    '</aside>';
  document.body.appendChild(root);
  var $ = function (k) { return root.querySelector('[data-cart="' + k + '"]'); };
  var panel = root.querySelector('.cartdrawer__panel');

  /* ── the one renderer ── */
  function renderCart() {
    var c = state.cart;
    var items = (c && c.items) || [];
    var count = (c && c.item_count) || 0;
    document.querySelectorAll('[data-cart-link]').forEach(function (l) {
      l.textContent = count ? 'Cart (' + count + ')' : 'Cart';
    });
    root.classList.toggle('is-busy', state.busy);
    var err = $('error');
    err.hidden = !state.error;
    err.textContent = state.error;
    if (!c) return;

    var hasDeposit = items.some(function (i) { return i.selling_plan_allocation; });
    var type = function (t) { return items.some(function (i) { return i.product_type === t; }); };
    $('eyebrow').textContent = hasDeposit ? 'Your pre-order' : 'Your bag';
    $('title').textContent = count ? 'Almost yours.' : 'Your bag';
    $('count').textContent = count ? (count === 1 ? '1 piece' : count + ' pieces') : '';
    $('empty').hidden = count > 0;
    /* free shipping on 2+ pieces (automatic discount, AE/GB/US); a lone
       couture gown already ships free, so it gets no nudge */
    var ship = $('ship');
    var paidShip = items.some(function (i) { return !i.selling_plan_allocation; });
    ship.hidden = count === 0 || (count === 1 && !paidShip);
    ship.textContent = count >= 2 ? 'Your order ships free.' : 'Add one more piece and your order ships free.';
    ship.classList.toggle('is-free', count >= 2);
    $('foot').hidden = count === 0;

    $('items').innerHTML = items.map(function (it, n) {
      var props = Object.keys(it.properties || {}).filter(function (k) {
        var v = it.properties[k];
        return k.charAt(0) !== '_' && v != null && String(v).trim() !== '';
      }).map(function (k) {
        return '<li>' + esc(k) + ': ' + esc(it.properties[k]) + '</li>';
      }).join('');
      /* variant options first (Colour on accessories); the default "Title" option is skipped */
      var opts = (it.options_with_values || []).filter(function (o) {
        return o.name !== 'Title' && o.value && o.value !== 'Default Title';
      }).map(function (o) { return '<li>' + esc(o.name) + ': ' + esc(o.value) + '</li>'; }).join('');
      props = opts + props;
      var plan = it.selling_plan_allocation ? '<p class="cartdrawer__plan"><span>' + esc(it.selling_plan_allocation.selling_plan.name) + '</span></p>' : '';
      var kind = it.selling_plan_allocation ? 'Haute couture' : (it.product_type || '');
      var img = it.featured_image && it.featured_image.url
        ? it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200'
        : '';
      return '<article class="cartdrawer__item" data-line="' + (n + 1) + '">' +
        '<a class="cartdrawer__thumb" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="84" height="112" loading="lazy" />' : '') + '</a>' +
        '<div class="cartdrawer__info">' +
          (kind ? '<p class="cartdrawer__kind">' + esc(kind) + '</p>' : '') +
          '<a class="cartdrawer__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          plan +
          (props ? '<ul class="cartdrawer__props">' + props + '</ul>' : '') +
          '<div class="cartdrawer__controls">' +
            '<div class="cartdrawer__qty" role="group" aria-label="Quantity of ' + esc(it.product_title) + '">' +
              '<button type="button" data-cart-action="dec" aria-label="One fewer">&minus;</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-cart-action="inc" aria-label="One more">+</button>' +
            '</div>' +
            '<button type="button" class="cartdrawer__remove" data-cart-action="remove">Remove</button>' +
          '</div>' +
        '</div>' +
        '<p class="cartdrawer__price">' + money(it.final_line_price) + '</p>' +
      '</article>';
    }).join('');

    /* upsell: the Sovereign Cape, only beside Silver Sovereign and only once */
    var up = $('upsell');
    var wantCape = items.some(function (i) { return i.handle === CAPE_FOR; }) && !items.some(function (i) { return i.handle === CAPE; });
    up.hidden = !(wantCape && state.cape);
    if (!up.hidden) {
      up.innerHTML = '<p class="eyebrow">Complete the look</p>' +
        '<div class="cartdrawer__upsell-row">' +
          (state.cape.img ? '<img src="' + esc(state.cape.img) + '" alt="" width="56" height="74" loading="lazy" />' : '') +
          '<div><p class="cartdrawer__name">' + esc(state.cape.title) + '</p><p class="cartdrawer__upsell-price">' + money(state.cape.price) + '</p></div>' +
          '<button type="button" class="btn btn--ghost cartdrawer__upsell-add" data-cart-action="add-cape">Add</button>' +
        '</div>';
    }
    if (wantCape && !state.cape && !state.capeLoading) loadCape();

    $('total').textContent = money(c.total_price);
    var due = c.checkout_charge_amount;
    var dueRow = $('due-row');
    dueRow.hidden = !(hasDeposit && typeof due === 'number' && due !== c.total_price);
    if (!dueRow.hidden) $('due').textContent = money(due);
    var notes = [];
    if (hasDeposit) notes.push('Couture gowns are secured with a 50% deposit; the balance is charged before delivery.');
    if (type('Ready-to-Wear')) notes.push('Ready-to-wear is paid in full and produced within one week.');
    if (type('Bridal') || type('Evening')) notes.push((type('Bridal') && type('Evening') ? 'Bridal and evening gowns are' : type('Bridal') ? 'Bridal gowns are' : 'Evening gowns are') + ' paid in full; the atelier confirms timing after you order.');
    notes.push('Delivery and discount codes are applied at checkout.');
    $('note').textContent = notes.join(' ');

    /* USP bar (Kevin 2026-10-21: a slim bar, no "made for your order" or
       WhatsApp line): quality, the returns promise that fits the bag, and
       secure checkout. Couture has no 10-day exchange, so a couture-only bag
       shows the 72-hour reservation refund instead. */
    var usps = [['quality', 'Premium quality']];
    if (type('Ready-to-Wear')) usps.push(['refund', '10-day exchange']);
    else if (hasDeposit) usps.push(['refund', '72-hour cancellation']);
    usps.push(['lock', 'Secure checkout']);
    var ul = $('usps');
    ul.hidden = count === 0;
    ul.innerHTML = usps.map(function (u) {
      return '<li>' + svg(u[0], 18) + '<span>' + esc(u[1]) + '</span></li>';
    }).join('');
    renderRecs(items, count, !up.hidden);
  }

  /* "You may also like": real Ready-to-Wear pieces (Ready-to-Wear is the
     main seller), shown with RTW in the bag or an empty bag, never beside
     the cape suggestion. Each tile opens the piece's own page for its size. */
  function renderRecs(items, count, capeShown) {
    var box = $('recs');
    var inBag = {};
    items.forEach(function (i) { inBag[i.handle] = 1; });
    var wanted = !capeShown && (count === 0 || items.some(function (i) { return i.product_type === 'Ready-to-Wear'; }));
    if (wanted && !state.recs && !state.recsLoading) loadRecs();
    var list = (state.recs || []).filter(function (p) { return !inBag[p.handle]; }).slice(0, 3);
    box.hidden = !(wanted && list.length);
    if (box.hidden) return;
    box.innerHTML = '<div class="cartdrawer__recs-head"><p class="eyebrow">' + (count ? 'You may also like' : 'Ready-to-Wear') + '</p><a href="/collections/ready-to-wear">View all</a></div>' +
      '<div class="cartdrawer__recs-row">' + list.map(function (p) {
        return '<a class="cartdrawer__rec" href="/products/' + esc(p.handle) + '">' +
          '<span class="cartdrawer__rec-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="120" height="160" />' : '') + '</span>' +
          '<span class="cartdrawer__rec-name">' + esc(p.title) + '</span>' +
          '<span class="cartdrawer__rec-price">' + money(p.price) + '</span>' +
        '</a>';
      }).join('') + '</div>';
  }
  function loadRecs() {
    state.recsLoading = true;
    getJSON('/collections/ready-to-wear/products.json?limit=24').then(function (j) {
      state.recs = (j.products || []).filter(function (p) {
        return p.variants && p.variants.some(function (v) { return v.available; });
      }).map(function (p) {
        var src = p.images && p.images[0] && p.images[0].src;
        return { handle: p.handle, title: p.title, price: Math.round(parseFloat(p.variants[0].price) * 100), img: src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '' };
      });
      renderCart();
    }).catch(function () { state.recs = []; }).then(function () { state.recsLoading = false; });
  }

  function loadCape() {
    state.capeLoading = true;
    getJSON('/products/' + CAPE + '.js').then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) return;
      var g = (p.selling_plan_groups || [])[0];
      var sp = g && g.selling_plans && g.selling_plans[0];
      state.cape = { id: v.id, plan: sp ? sp.id : null, title: p.title, price: v.price, img: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image + '&width=120' : '' };
      renderCart();
    }).catch(function () {}).then(function () { state.capeLoading = false; });
  }

  /* ── state transitions ── */
  /* /cart.js lacks the due-today figure; the drawer view template returns it */
  function refresh() {
    /* no Accept: json here, or Shopify answers with plain cart JSON and skips the view */
    var due = fetch('/cart?view=drawer')
      .then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
    return Promise.all([getJSON('/cart.js'), due]).then(function (res) {
      var c = res[0];
      if (typeof res[1].checkout_charge_amount === 'number' && res[1].total_price === c.total_price) c.checkout_charge_amount = res[1].checkout_charge_amount;
      state.cart = c; renderCart(); return c;
    });
  }
  function run(task) {
    if (state.busy) return Promise.resolve();
    state.busy = true; state.error = ''; renderCart();
    return task().then(function () { return refresh(); })
      .catch(function (e) { state.error = e.message; return refresh().catch(function () {}); })
      .then(function () { state.busy = false; renderCart(); });
  }
  function change(line, qty) {
    return run(function () { return postJSON('/cart/change.js', { line: line, quantity: qty }); });
  }

  var lastFocus = null;
  function open() {
    if (onCartPage) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; /* forced reflow, never rAF (hidden tabs stall it) */
    root.classList.add('is-open');
    state.open = true;
    document.documentElement.setAttribute('data-cart-open', '');
    document.body.style.overflow = 'hidden';
    panel.focus({ preventScroll: true });
    if (!state.cart) refresh().catch(function (e) { state.error = e.message; renderCart(); });
  }
  function close() {
    if (!state.open) return;
    root.classList.remove('is-open');
    state.open = false;
    document.documentElement.removeAttribute('data-cart-open');
    document.body.style.overflow = '';
    setTimeout(function () { if (!state.open) root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.elanrahCart = { open: open, close: close, refresh: refresh, render: renderCart, state: state };

  /* ── events ── */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-action]');
    if (!a) return;
    var act = a.getAttribute('data-cart-action');
    if (act === 'close') { e.preventDefault(); return close(); }
    if (act === 'add-cape' && state.cape) {
      var item = { id: state.cape.id, quantity: 1 };
      if (state.cape.plan) item.selling_plan = state.cape.plan;
      return run(function () { return postJSON('/cart/add.js', { items: [item] }); });
    }
    var row = a.closest('[data-line]');
    if (!row || !state.cart) return;
    var line = Number(row.getAttribute('data-line'));
    var q = state.cart.items[line - 1].quantity;
    if (act === 'inc') change(line, q + 1);
    if (act === 'dec') change(line, Math.max(0, q - 1));
    if (act === 'remove') change(line, 0);
  });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  document.addEventListener('click', function (e) {
    var l = e.target.closest('[data-cart-link]');
    if (!l || onCartPage || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });

  /* Product forms (PDP buy box, the cape row): the size guard and the
     measurement filter run in the capture phase first; this listener only
     sees submits they let through. A failed add shows its message in place;
     the native post stays the fallback if fetch itself is unavailable. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form.action || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var msg = form.querySelector('[data-add-error]');
    if (msg) msg.hidden = true;
    var fd = new FormData(form);
    fd.delete('return_to');
    getJSON('/cart/add.js', { method: 'POST', body: fd })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) {
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'fineprint cartdrawer__form-error';
          msg.setAttribute('data-add-error', '');
          msg.setAttribute('role', 'alert');
          (btn || form.lastChild).insertAdjacentElement('afterend', msg);
        }
        msg.textContent = err.message;
        msg.hidden = false;
      })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* The RTW quick add (above) dispatches this after its own successful add. */
  document.addEventListener('elanrah:cart-added', function () { refresh().then(open).catch(function () {}); });

  /* Counts on first load, so the header is right before anything is clicked. */
  refresh().catch(function () {});
})();

/* ── Country / currency selector (Shopify Markets) ───────────────────────
   snippets/country-selector: picking a country submits the localization
   form straight away; the Update button stays only as the no-JS fallback. */
document.querySelectorAll('[data-locale-select]').forEach(function (sel) {
  var go = sel.form && sel.form.querySelector('[data-locale-go]');
  if (go) go.hidden = true;
  sel.addEventListener('change', function () { sel.form.submit(); });
});
